/** Classic K: a cave packed with boulders, where every dig starts a slide (docs/spec/03 §2). */

import type { CaveDef } from '../types';

export const caveK: CaveDef = {
  id: 'K',
  name: 'LANDSLIDE',
  hint: 'Everything here wants to fall. Let it, then run.',
  intermission: false,
  colors: [9, 10, 7],
  diamondValue: 20,
  extraValue: 35,
  fill: { base: '.', items: [['r', 30], ['d', 7]] },
  levels: [
    { seed: 2401, diamonds: 18, time: 130 },
    { seed: 2402, diamonds: 21, time: 120 },
    { seed: 2403, diamonds: 24, time: 110 },
    { seed: 2404, diamonds: 27, time: 100 },
    { seed: 2405, diamonds: 30, time: 90 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W....??????????????????????????????????W',
    'W.P..??????????????????????????????????W',
    'W....??????????????????????????????????W',
    'W....??????????????????????????????????W',
    'W????????????????????????????????www???W',
    'W???www????????????????????????www?????W',
    'W?????www????????????????????www???????W',
    'W???????www????????????????www?????????W',
    'W?????????www????        www???????????W',
    'W???????????www??        ??????????????W',
    'W?????????????www        ??????????????W',
    'W???????????????wwwwwwwwww?????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W????dddd.dddd.dddd???????????????....?W',
    'W????..............???????????????..X.?W',
    'W?????????????????????????????????....?W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
